// return only numbers
const validPhone = (phoneNumber) => {

  const regex = /[0-9]/gi;

  if (phoneNumber) {
    phoneNumber = phoneNumber
    .match(regex, '')
    .join('');
  }

  return phoneNumber;
}


module.exports = {
  validPhone,
};